import { catalogService } from '@/services/api/catalog.service';
import { catalogModel } from '@/models/api/catalog.model';
import { sharedHelper, alertHelper } from '@/utils';
import i18n from '@/i18n';

export const CATALOG_MODULE = 'api/catalog';
export const GET_ALL_CATALOG = 'getAllCatalog';
export const CREATE_CATALOG = 'createCatalog';
export const GET_CATALOG = 'getCatalog';
export const UPDATE_CATALOG = 'updateCatalog';
export const UPDATE_CATALOG_STATUS = 'updateCatalogStatus';
export const DELETE_CATALOG = 'deleteCatalog';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 1,
            pageSize: 15,
            lastPage: 1,
            tableRowsCounts: 0,
            total: 0
        }
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true
    },
};

function showError(commit, error) {
    commit('failure');
    alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
}

async function refresh(dispatch, filter) { await dispatch(GET_ALL_CATALOG, { filter }); }

export const actions = {
    async [GET_ALL_CATALOG]({ commit }, { filter }) {
        commit('requesting');
        try {
            const result = await catalogService.getAll(filter);
            commit('listSuccess', result);
            return result;
        }
        catch (error) {
            showError(commit, error);
            return null;
        }
    },
    async [CREATE_CATALOG]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const result = await catalogService.store(data);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.createXSuccess', [i18n.t('module.catalog')]) });
            await refresh(dispatch, filter); return result;
        } catch (error) { showError(commit, error); return null; }
    },
    async [GET_CATALOG]({ commit }, { uuid }) {
        commit('requesting', 'detail');
        try {
            const result = await catalogService.show(uuid);
            commit('detailSuccess', result);
            return result;
        }
        catch (error) {
            showError(commit, error); return null;
        }
    },
    async [UPDATE_CATALOG]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const result = await catalogService.update(data); commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.updateXSuccess', [i18n.t('module.catalog')]) });
            await refresh(dispatch, filter); return result;
        } catch (error) {
            showError(commit, error);
            return null;
        }
    },
    async [UPDATE_CATALOG_STATUS]({ commit, dispatch }, { uuid, isActive, filter }) {
        commit('requesting', 'save');
        try {
            const result = await catalogService.updateStatus(uuid, isActive); commit('success');
            await refresh(dispatch, filter); return result;
        }
        catch (error) {
            showError(commit, error);
            return null;
        }
    },
    async [DELETE_CATALOG]({ commit, dispatch }, { uuid, filter }) {
        commit('requesting', 'save');
        try {
            const result = await catalogService.softDelete(uuid); commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.deleteXSuccess', [i18n.t('module.catalog')]) });
            await refresh(dispatch, filter); return result;
        } catch (error) {
            showError(commit, error);
            return null;
        }
    },
};

export const mutations = {
    requesting(state, type = 'list') { state.status[type] = false; },
    listSuccess(state, result) {
        state.list.data = (result?.data || []).map(catalogModel);
        state.list.pagination = sharedHelper.apiPaginationAdapter(result?.pagination || {});
        state.status.list = true;
    },
    detailSuccess(state, result) {
        const payload = result?.data || {};
        state.details = catalogModel(payload);
        state.status.detail = true;
    },
    success(state) {
        state.status = {
            list: true,
            detail: true,
            save: true
        };
    },
    failure(state) {
        state.status = {
            list: true,
            detail: true,
            save: true
        };
    },
};
